import React from 'react';

import {
  EditLessonForm,
  LESSON_INPUT_OPTIONS,
  NON_LIVE_LECTURE_LESSON_TYPES,
} from 'features/classCreation';
import EditableSection from 'components/EditableSection';
import Field from 'components/Field';
import LessonChip from '../LessonChip';

export default function EditNonLiveLectureForm({ academyTopic }) {
  const { lessons } = academyTopic || {};

  return (
    <Field
      label="Lecture Requirements"
      labelClassName="m-b-xs"
    >
      <div className="m-b-s">
        {NON_LIVE_LECTURE_LESSON_TYPES.map((lessonType) => (
          <LessonChip
            academyTopicId={academyTopic.id}
            lessonType={lessonType}
            title={LESSON_INPUT_OPTIONS[lessonType].label}
            key={lessonType}
          />
        ))}
      </div>
      {lessons.map((lesson) => {
        const { lesson_type: lessonType } = lesson;
        const label = LESSON_INPUT_OPTIONS[lessonType]?.label;

        return (
          label && (
            <EditableSection
              canEdit
              title={label}
              titleClassName="hint"
              className="m-b-s"
              key={lesson.id}
            >
              {(editableProps) => (
                <EditLessonForm
                  {...editableProps}
                  academyTopicId={academyTopic.id}
                  value={lesson}
                  label={label}
                />
              )}
            </EditableSection>
          )
        );
      })}
    </Field>
  );
}
